export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID; // Reemplaza con tu ID de medición

// Función para enviar datos de página vista
export const pageview = (url: string) => {
  GA_TRACKING_ID &&
    window.gtag("config", GA_TRACKING_ID, {
      page_path: url,
    });
};

// Función para eventos personalizados
export const event = ({ action, category, label, value }: any) => {
  window.gtag("event", action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};
